import { AvatarBoError } from './AvatarBoClient'

const MAX_RETRIES = 1

/** A 4xx is an answer, not a blip: retrying it only delays the message by seconds. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  const status = error instanceof AvatarBoError ? error.status : undefined
  if (status && status >= 400 && status < 500) {
    return false
  }

  return failureCount < MAX_RETRIES
}
